import * as React from 'react'
import { useEffect } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import SpinnerOverlay from '../../../../components/shared/spinner_overlay'
import OverviewCalendarTable from '../../../elements/warehouse_rent_list_app/warehouse_rent_list/overview_calendar_table'
import { Element, RentList } from '../../warehouse_rent_list_app/warehouse_rent_list/warehouse_rent_list_types'

interface WarehouseRentListOverviewProps {
  startDate: string
  endDate: string
  initialData: {
    rentedItems: Record<string, any>
    elementGroups: Record<string, string>
    groupedAvailableElements: Record<string, Element[]>
  }
  loadData: (data: any) => void
  groupedAvailableElements: Record<string, Element[]>
  elementGroups: Record<string, string>
  rentedItems: Record<string, any>
  rentElementRequestInProgress: boolean
  errors: string[]
  warehouseRentList?: RentList | null
  reservations?: any[]
  currentListId?: string | null
}

function WarehouseRentListOverview({
  startDate,
  endDate,
  initialData,
  loadData,
  groupedAvailableElements,
  elementGroups,
  rentedItems,
  rentElementRequestInProgress,
  errors,
}: WarehouseRentListOverviewProps): React.ReactElement {
  const { I18n } = window as any

  useEffect(() => {
    if (initialData && startDate && endDate) {
      const data = {
        elementGroups: initialData.elementGroups || {},
        groupedAvailableElements: initialData.groupedAvailableElements || {},
        rentedItems: initialData.rentedItems || {},
      }
      loadData(data)
    }
  }, [startDate, endDate, initialData, loadData])

  // Don't show loading state, show calendar even if warehouseRentList is not loaded yet
  const rentListData = {
    id: 0,
    startDate,
    endDate,
    warehouse_id: 0,
  }

  // Show fallback if no data
  if (!initialData || !startDate || !endDate) {
    return <div>Loading overview data...</div>
  }

  // Show fallback if no elements
  const hasElements =
    initialData.groupedAvailableElements && Object.keys(initialData.groupedAvailableElements).length > 0

  if (!hasElements) {
    return <div>No elements available for the selected period.</div>
  }

  return (
    <div className="rent-list">
      <Modal isOpen={errors && errors.length > 0} size="lg">
        <ModalHeader>{I18n.t('elements.rent_list.error_modal_header')}</ModalHeader>
        <ModalBody>{errors ? errors.join('. ') : ''}</ModalBody>
      </Modal>
      <SpinnerOverlay isActive={rentElementRequestInProgress}>
        <OverviewCalendarTable
          startDate={startDate}
          endDate={endDate}
          groupedAvailableElements={groupedAvailableElements || initialData.groupedAvailableElements || {}}
          elementGroups={elementGroups || initialData.elementGroups || {}}
          rentedItems={rentedItems || initialData.rentedItems || {}}
          rentList={rentListData}
        />
      </SpinnerOverlay>
    </div>
  )
}

WarehouseRentListOverview.defaultProps = {
  rentElementRequestInProgress: false,
  rentedItems: {},
  groupedAvailableElements: {},
  elementGroups: {},
  errors: [],
  reservations: [],
  currentListId: null,
  warehouseRentList: null,
}

export default WarehouseRentListOverview
